import { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { PAGE_NAME } from "reducers/menu";
import { useLocation } from "react-router-dom";
import { AI_getUserData } from "APIs/user";
import { useInstance } from "easy-redux-http-call";
import { useParams } from "react-router-dom/dist/index";

// for loading
export const useIntersection = ({ root = null, rootMargin, threshold = 0 }) => {
  const [entry, updateEntry] = useState({});
  const [node, setNode] = useState(null);
  const observer = useRef(
    new window.IntersectionObserver(([entry]) => updateEntry(entry), {
      root,
      rootMargin,
      threshold,
    })
  );
  useEffect(() => {
    const { current: currentObserver } = observer;
    currentObserver.disconnect();
    if (node) currentObserver.observe(node);
    return () => currentObserver.disconnect();
  }, [node]);
  return [setNode, entry];
};

// store page name on redux state
export const useStorePageName = ({ data }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch({
      type: PAGE_NAME,
      payload: data,
    });
  }, []);
};

export const useAuthenticate = () => {
  let { employeeid } = useParams();
  const getUserData = useInstance(AI_getUserData);
  const checkInProbation = getUserData?.data?.user?.in_probation;
  const tempUrl = `employee/${employeeid}/details`;
  const authenticatRoutes = {
    departments: getUserData?.data?.user?.is_access_to_department&&getUserData?.data?.user?.is_submit ,
    "emplyoee/add": getUserData?.data?.user?.is_access_to_employee&&getUserData?.data?.user?.is_submit,
    [tempUrl]: getUserData?.data?.user?.is_access_to_employee&&getUserData?.data?.user?.is_submit,
    emplyoee: getUserData?.data?.user?.is_access_to_employee&& getUserData?.data?.user?.is_submit,
    roles: getUserData?.data?.user?.is_access_to_roles &&getUserData?.data?.user?.is_submit,
    project: getUserData?.data?.user?.is_access_to_project && getUserData?.data?.user?.is_submit,
    "bank-details": getUserData?.data?.user?.only_employee_view &&getUserData?.data?.user?.is_submit,
    document: getUserData?.data?.user?.only_employee_view&& getUserData?.data?.user?.is_submit,
    work: getUserData?.data?.user?.only_employee_view&& getUserData?.data?.user?.is_submit,
    education: getUserData?.data?.user?.only_employee_view&&getUserData?.data?.user?.is_submit,
    address: getUserData?.data?.user?.only_employee_view&&getUserData?.data?.user?.is_submit,
    nominee: getUserData?.data?.user?.only_employee_view&& getUserData?.data?.user?.is_submit,
    "personal-details": getUserData?.data?.user?.only_employee_view&&getUserData?.data?.user?.is_submit,
    projects: getUserData?.data?.user?.only_employee_view&&getUserData?.data?.user?.is_submit,
    leave: !checkInProbation && getUserData?.data?.user?.only_employee_view&&getUserData?.data?.user?.is_submit,
  };
  const location = useLocation();
  const path = location.pathname.replace("/", "");
  return authenticatRoutes[path];
};
